import FeaturesAIList from './FeaturesAIList'

export default FeaturesAIList
